// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddPost_wrapper__lgZl-","textarea":"AddPost_textarea__3_rXh","button":"AddPost_button__3bNPk"};